import api from "./api";
// 新增投票
export const postVoteCreate = params => {
  return api('post', `/v1/management/vote/create`, params);
};

// 修改投票
export const postVoteUpdate = params => {
  return api('post', `/v1/management/vote/update`, params);
};

// 投票列表
export const postVoteVoteList = params => {
  return api('post', `/v1/management/vote/voteList`, params);
};

// 删除投票
export const voteDelete = id => {
  return api("get", `/v1/management/vote/delete/${id}`);
};

// 查询详情
export const voteDetails = id => {
  return api("get", `/v1/management/vote/details/${id}`);
};

// 发布
export const votePublish = id => {
  return api("get", `/v1/management/vote/publish/${id}`);
};

// 投票结果下载
export const voteExportList = id => {
  return api("get", `/v1/management/vote/voteExportList/${id}`, {},
  {
    responseType: "blob",
  });
};

// 下架
export const votesoldOut = id => {
  return api("get", `/v1/management/vote/soldOut/${id}`);
};